module.exports = __webpack_public_path__ + "components/rewards/sport-pursuit/static/logo-288e3b4054a1003733ee2c6cbd36429f.webp";